import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { sweetAlert } from '../../../utils/swal';
import { DriversService } from '../drivers-service/drivers-service';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { EquipmentService } from '../../equipments/equipment-service/equipment.service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { FleetService } from '../../fleet/fleet-service/fleet.service';
import { StaffService } from '../../staffs/staff-service/staff.service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { dataURItoBlob } from 'src/app/utils/utils.common';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
@Component({
  selector: 'app-driver-profile-dashboard',
  templateUrl: './driver-profile-dashboard.component.html',
  styleUrls: ['./driver-profile-dashboard.component.css']
})
export class DriverProfileDashboardComponent implements OnInit, OnDestroy {
  @Input() driverProfileModalObj;
  @Output() onCloseModal = new EventEmitter<any>();
  driverDetails = null;
  password = null;
  imageModalUrl = null;
  path = null;
  user:any
  driverId;
  passwordType;
  showErrorMessage = false;
  dayOrder = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
  spaceTypeList = {};
  equipmentList = {};
  fleetData;
  driverDetailProfileModal;
  staffList;
  serviceAreas;
  status = "active";
  fundingSources = [];
  preFundingSources = {};
  preStationManager: { [id: string]: string } = {};
  isSignature = false;
  driverUserId:any;
  preDrivers:any
  days = ['Sunday','Monday' , 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  // drivers = [
  //   "66ba2c0434ec68dde0c506de",
  //   "66c31d358f24cb56cae26a57",
  //   "66c847bc531bc79aa852ddf2",
  //   "66c855a3531bc79aa852de2b"
  // ]

  constructor(
    private corporateService : CorporateService,
    private serviceArea : ServiceAreasService,
    private staffService: StaffService,
    private fleetService: FleetService,
    private driverService: DriversService,
    private equipmentService: EquipmentService,
    private levelOfServiceService: LevelOfServiceService,
    private sharedDataService: SharedDataService,
  ) { }

  ngOnInit() {
    this.driverUserId = this.driverProfileModalObj._id;
    this.driverService
      .getDriverProfile(this.driverProfileModalObj._id)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverDetails = data;

          if((this.driverDetails && this.driverDetails.fleet) && this.driverDetails.fleet._id){
            this.getFleetbyId();
          }

          this.getcorporateUsers()
          this.getSpaceTypeList();
          this.getEquipmentList()
          this.getStaffList()
          this.getServiceAreas();
          this.getUser()
        }
      });

  }

   getUser() {
      this.sharedDataService
        .getUser()
        .pipe(takeUntil(takeUntilDestroyed(this)))
        .subscribe(data => {
          if (data) {
            this.user = data;
            this.getDriverList();
          }
        });
    }

  getDriverList() {
    this.driverService.getDrivers(this.user._id, 'active')
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preDrivers = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        }
      );
  }

  getSortingDays(days) {
    return days.sort((a, b) => this.dayOrder.indexOf(a) - this.dayOrder.indexOf(b));
  }

  generatePassword(passwordType) {
    this.passwordType = passwordType;

    if (passwordType === 'auto') {
      this.password = (new Date().getTime()).toString(36).substring(0, 9);
    }

    else if (passwordType === 'manual') {
      this.password = "";
    }
  }

  resetPassword() {
    if (!this.password) {
      this.showErrorMessage = true;
      return;
    }
    sweetAlert('Are you sure you want to Reset Password?', 'An Email with updated password will be send to driver\'s email.', 'warning', 'Yes', 'No')
      .then((result) => {
        if (result.value) {
          const newPassData = {
            driverId: this.driverProfileModalObj._id,
            newPassword: this.password
          };
          this.password = null;
          this.driverService
            .resetDriverPassword(newPassData)
            .pipe(takeUntil(takeUntilDestroyed(this)))
            .subscribe(data => {
              if (data) {
                // sweetAlert('Success', data.message, 'success', 'Ok');
                this.passwordType = null;
              }
            }, err => {
              sweetAlert('Error', err, 'error', 'Ok');
            });
        } else {
          this.password = null;
        }
      });
  }
  modalClose() {
    this.onCloseModal.emit(false);
  }

  getSpaceTypeList() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.spaceTypeList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getEquipmentList() {
    let queryParams = {
      isAddon: false,
    }
    this.equipmentService
      .getEquipments(queryParams)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.equipmentList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getFleetbyId() {
    this.fleetService
      .getFleetDataById(this.driverDetails.fleet._id)
      .subscribe((data) => {
        if (data) {
          this.fleetData = data;
        }
      });
  }

  getStaffList() {
    this.staffService
      .getStaffList()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.staffList = data;

        this.staffList.forEach(sm => {
        this.preStationManager[sm._id] = sm.displayName;
      });
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getStationManager(stationManagerId) {
    if(stationManagerId){
      const stationManager = this.staffList.find(sm => sm._id == stationManagerId);
      return stationManager ? stationManager.displayName : '';
    }
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreas = data
          }
        });
  }

  getServiceAreaByIds(serviceAreasID){
    return this.serviceAreas.filter(s => serviceAreasID.includes(s._id)).map(s => s.name);
  }

  getcorporateUsers() {
    this.corporateService
      .getCorporateUsers(this.status)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data && data.length) {
          this.fundingSources = data;
          this.preFundingSources = this.fundingSources.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getCorporate(id) {
    return this.fundingSources[id];
}

openSigModal() {
  this.isSignature = true;
}
closeModal() {
  this.isSignature = false;
}

saveSignature(evt) {
    this.isSignature = false;
    this.driverDetails.driverSignatureImage = evt;
    const imageBlob = dataURItoBlob(evt);
    const imageFile = new File([imageBlob], "signature.png", { type: 'image/png' });
    const payload = {
      _id: this.driverUserId,
      driverSignatureImage: imageFile
    };
    this.driverService
      .uploadSignature(payload)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          console.log("Data",data)
        }
      });
  }


  ngOnDestroy(): void {
  }
}
